import React, { useEffect, useState } from 'react';
import { BookOpen } from 'lucide-react';
import api from '../../utils/api';

const UserCourses = () => {
  const [orders, setOrders] = useState([]);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEnrolledCourses();
  }, []);

  const fetchEnrolledCourses = async () => {
    try {
      const response = await api.get('/orders');
      const allOrders = response.data;
      setOrders(allOrders);
      
      // Extract all courses from approved orders only
      const allCourses = [];
      for (const order of allOrders) {
        if (order.admin_approved && order.payment_status === 'completed') {
          for (const item of order.items) {
            if (item.product_type === 'course') {
              allCourses.push(item);
            }
          }
        }
      }
      setCourses(allCourses);
    } catch (error) {
      console.error('Failed to fetch courses:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen pt-24 pb-16 px-6 flex items-center justify-center">
        <div className="text-2xl">Loading courses...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-24 pb-16 px-6" data-testid="user-courses-page">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold mb-8" data-testid="courses-title">My Courses</h1>

        {courses.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {courses.map((course, index) => (
              <div key={index} className="glass-card p-6" data-testid={`course-${index}`}>
                <h3 className="text-xl font-semibold mb-2">{course.name}</h3>
                <p className="text-muted-foreground text-sm mb-4">
                  Enrolled course - lifetime access
                </p>
                <button
                  className="w-full px-4 py-2 bg-primary text-primary-foreground rounded-lg font-semibold hover:bg-primary/90 transition-all flex items-center justify-center gap-2"
                  data-testid={`start-course-${index}`}
                >
                  <BookOpen className="w-4 h-4" />
                  Continue Learning
                </button>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-16 glass-card" data-testid="no-courses">
            <BookOpen className="w-16 h-16 mx-auto mb-4 text-muted-foreground" />
            <h2 className="text-2xl font-bold mb-4">No courses yet</h2>
            <p className="text-muted-foreground">Enroll in courses to access them here</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserCourses;
